
import { defineComponent } from "vue";
import { v4 as uuid } from "uuid";

export default defineComponent({
  name: "InputCheckbox",
  props: {
    value: { type: Object },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    label: { type: String },
  },
  setup(props, context) {
    const uuidValue = uuid().toString();
    return {
      context,
      uuidValue,
    };
  },
});
